<template>
  <div>
    <el-breadcrumb style="margin-top:20px" separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/news', query:{channelId: channelDetail.id}}">{{channelDetail.channelName}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{newsDetail.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="home-public-wrap news-content" style="margin-top: 20px;">
      <h2>{{newsDetail.title}}</h2>
      <span class="publishDate">{{newsDetail.publishDate | formatDate}}</span>
      <div class="content" v-html="newsDetail.content">{{newsDetail.content}}</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getNewsDetailStatic } from '@/api/news'
import { getChannelDetail } from '@/api/channel'
export default {
  data() {
    return {
      newsDetail: {},
      channelDetail: {}
    }
  },
  methods: {
    getNewsDetailStaticData() {
      getNewsDetailStatic(this.$route.query.newsId).then(res => {
        console.log(res)
        this.newsDetail = res.data
      })
    },
    getChannelDetailData() {
      getChannelDetail(this.$route.query.channelId).then(res => {
        this.channelDetail = res.data
      })
    }
  },
  mounted() {
    this.getNewsDetailStaticData()
    this.getChannelDetailData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>

<style>
.news-content h2 {
  font-size: 22px;
  color: #666;
  font-weight: 400;
  padding-bottom: 15px;
}
.news-content span.publishDate {
  font-size: 12px;
  color: #999;
  font-weight: 400;
}
.news-content .content {
  padding-top: 30px;
}
.news-content .content p {
  line-height: 30px;
}
.news-content .content img {
  max-width: 500px;
  display: block;
  margin: 10px auto;
}
</style>
